import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// Channels
export const channelsList = params => Http.get(`/admin/webhook-channels${serialize(params)}`)
export const channelById = id => Http.get(`/admin/webhook-channels/${id}`)
export const createChannel = data => Http.post('/admin/webhook-channels', data)
export const updateChannel = (id, data) => Http.put(`/admin/webhook-channels/${id}`, data)
export const deleteChannel = id => Http.delete(`/admin/webhook-channels/${id}`)
// How many people asked for a deal channel in a language with none, per (language, country), the biggest first.
export const dealChannelInterests = () => Http.get('/admin/deal-channel-interests')
export const testChannel = id => Http.post(`/admin/webhook-channels/${id}/test`)

// The Deals screen's "send test": one labelled sample to a LIVE channel. The API refuses it unless
// the channel is flagged allow_test and the request says confirm: true.
export const dealTestChannel = id => Http.post(`/admin/webhook-channels/${id}/deal-test`, { confirm: true })

// Fetched only when an admin asks, never as part of listing channels — see the
// note on WebhookChannelTransformer about a screenshot being enough to take
// over the bot.
export const revealChannelSecret = id => Http.get(`/admin/webhook-channels/${id}/secret`)

// Triggers
export const triggersList = channelId => Http.get(`/admin/webhook-channels/${channelId}/triggers`)
export const createTrigger = (channelId, data) => Http.post(`/admin/webhook-channels/${channelId}/triggers`, data)
export const updateTrigger = (channelId, triggerId, data) =>
  Http.put(`/admin/webhook-channels/${channelId}/triggers/${triggerId}`, data)
export const deleteTrigger = (channelId, triggerId) =>
  Http.delete(`/admin/webhook-channels/${channelId}/triggers/${triggerId}`)

// Available event keys
export const fetchEventKeys = () => Http.get('/admin/webhook-channels/events')

// Targets (sub-channels)
export const targetsList = channelId => Http.get(`/admin/webhook-channels/${channelId}/targets`)
export const createTarget = (channelId, data) => Http.post(`/admin/webhook-channels/${channelId}/targets`, data)
export const updateTarget = (channelId, targetId, data) =>
  Http.put(`/admin/webhook-channels/${channelId}/targets/${targetId}`, data)
export const deleteTarget = (channelId, targetId) =>
  Http.delete(`/admin/webhook-channels/${channelId}/targets/${targetId}`)
